export const TABLET_BREAKPOINT = 767
export const MEDIUM_BREAKPOINT = 834
export const LARGE_BREAKPOINT = 1024
export const XLARGE_BREAKPOINT = 1440
